export * from "./activate.component";
export * from "./activate.module";
export * from "./activate.service"; 


// WEBPACK FOOTER //
// ./src/app/public/activate/index.ts